import { SortFieldInfo } from "./SortFieldInfo";
import { TableColumn } from "./TableColumn";

export class GeneratedTableColumn extends TableColumn {
    override canBeMoved(): boolean {
        return false;
    }

    override canBeRemoved(): boolean {
        return false;
    }

    override isSerialized(): boolean {
        return false;
    }

    override async getSortFields(): Promise<SortFieldInfo[]> {
        return [];
    }
}
